import './App.css';
import Home from './pages/Home/home.jsx';
import ErrorPage from './pages/error.jsx';
import ExampleCrafMyPDF from './pages/exempleCraftMyPDF.jsx';
import {
    BrowserRouter ,
    Routes,
    Route
} from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./queries/apolloClient.js";

function App() {
    return (
        <ApolloProvider client={client}>
            <BrowserRouter>
                <Routes>
                    <Route path="pdf" element={<ExampleCrafMyPDF />}/>
                    <Route index element={<Home />} />
                    <Route path='*' element={<ErrorPage />} />
                </Routes>
            </BrowserRouter>
        </ApolloProvider>
    );
}

export default App;
